/**
 * useAnalytics — una visita de página (GA4) en cada cambio de ruta, con nombre legible, y el
 * título de la pestaña por sección. Si hay un jugador con sesión (PIN) se lo identifica.
 * (El scroll y el tiempo en página ya los mide GA4 solo: "scroll" y "user_engagement".)
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { identificarJugador, nombreDePagina, trackPageView } from '@/lib/analytics';

function jugadorEnSesion(): string | null {
  try {
    const s = JSON.parse(localStorage.getItem('jugador_session') || 'null');
    return s?.jugador_id || null;
  } catch {
    return null;
  }
}

/** Va una sola vez dentro de <BrowserRouter>. */
export function usePageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    const nombre = nombreDePagina(path);
    document.title = nombre === 'Inicio' || nombre === 'Otra' ? 'Boliche Nicaragua 🎳' : `${nombre} | Boliche Nicaragua`;
    identificarJugador(jugadorEnSesion());
    trackPageView(path, nombre);
  }, [location.pathname, location.search]);
}
